module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/RSS-0f6c6b1ede882a9a4f1d2ba38e81e406.svg";